import { render, staticRenderFns } from "./supplierRFQHistories.vue?vue&type=template&id=e9288452&scoped=true&"
import script from "./supplierRFQHistories.vue?vue&type=script&lang=js&"
export * from "./supplierRFQHistories.vue?vue&type=script&lang=js&"
import style0 from "./supplierRFQHistories.vue?vue&type=style&index=0&id=e9288452&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9288452",
  null
  
)

component.options.__file = "supplierRFQHistories.vue"
export default component.exports